<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (tap)="modalController.dismiss()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
            <ion-button (tap)="openModalAddContact()" *ngIf="document">
                <ion-icon slot="icon-only" name="add"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-searchbar placeholder="Search Contact" debounce="300" [(ngModel)]="queryText">
        </ion-searchbar>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-refresher slot="fixed" (ionRefresh)="fetchContacts($event)">
        <ion-refresher-content
                pullingIcon="arrow-dropdown"
                pullingText="Pull to refresh"
                refreshingSpinner="circles"
                refreshingText="Updating Contacts...">
        </ion-refresher-content>
    </ion-refresher>
    <ion-virtual-scroll [items]="contactList | filterContact: queryText">
        <ion-item *virtualItem="let cont" (click)="modalController.dismiss(cont)">
            <ion-label>
                <h4> {{ cont.name }} </h4>
                <p *ngIf="cont.phone"> {{ cont.phone }} </p>
                <p *ngIf="cont.email"> {{ cont.email }} </p>
            </ion-label>
        </ion-item>
    </ion-virtual-scroll>
</ion-content>
